import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import mixins from './mixins.js'
import VueGtm from 'vue-gtm'
import VueMeta from 'vue-meta'
import i18n from './i18n'
import VueLocalStorage from 'vue-localstorage'
import '@babel/polyfill'
import VueJsonLD from 'vue-jsonld'
import { hasOptionalConsent, prepareConsentStorage } from './analytics/consent'
import { initializeMatomo } from './analytics/matomo'

Vue.config.productionTip = false

Vue.mixin({
  methods: {
    arrayRemoveDuplicates (ar = []) {
      return mixins.arrayRemoveDuplicates(ar)
    },
    getObjectWithIDFromArr (ar = [], id) {
      return mixins.getObjectWithIDFromArr(ar, id)
    },
    isDesktop () {
      return this.$vuetify.breakpoint.mdAndUp
    },
    trackScreenView (screenName) {
      // console.log('trackScreenView()')
      if (typeof screenName === 'undefined') {
        console.warn('#1 trackScreenView(undefined) -> not calling')
        return
      }
      this.$gtm.trackView(screenName, '')
    },
    trackEvent (action, category = '', label = '', value = '', nonInteraction = false) {
      if (typeof action === 'undefined') {
        console.warn('#2 trackEvent(undefined) -> not calling')
        return
      }
      this.$gtm.trackEvent({
        event: null, // Event type [default = 'interaction'] (Optional)
        category: category,
        action: action,
        label: label,
        value: value,
        noninteraction: nonInteraction // (Optional)
      })
    },
    debounce (func, delay = 300) {
      let debounceTimer
      return function () {
        const context = this
        const args = arguments
        clearTimeout(debounceTimer)
        debounceTimer = setTimeout(() => func.apply(context, args), delay)
      }
    },
    encodeDataForURL (data = {}) {
      return mixins.encodeData(data)
    },
    decodeCode (code = '') {
      return mixins.decodeCode(code)
    },
    isMtabletIncludedInSelection (extModsData, allExtModData) {
      return mixins.isMtabletIncludedInSelection(extModsData, allExtModData)
    },
    removeItemsFromArray (arr = [], arr2 = []) {
      return mixins.removeItemsFromArray(arr, arr2)
    }
  }
})

Vue.use(VueJsonLD)

const initialConsent = prepareConsentStorage()

Vue.use(VueGtm, {
  id: process.env.VUE_APP_GTM_ID || 'GTM-PD7L8PQ',
  enabled: hasOptionalConsent(initialConsent)
})

Vue.use(VueLocalStorage)

Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true
})

new Vue({
  router,
  store,
  i18n,
  vuetify,
  render: h => h(App)
}).$mount('#app')

Vue.nextTick(() => {
  initializeMatomo({
    router,
    hasCookieConsent: hasOptionalConsent(initialConsent),
    waitForDom: Vue.nextTick
  })
})
